<template>
    <div class="faDetail-useInfo">
        <div class="useInfo-choice js-useSelect">
            <div class="" :class="{ active: faq.suggestionType == 1}" @click="onSuggestionClick(1)">
                <img class="useInfo-icon"
                    src="https://resource.rcclchina.com.cn/Faq/useIconN.png" alt="有用">
                <img class="useInfo-iconActive" src="https://resource.rcclchina.com.cn/Faq/useIconWN.png" alt="有用">
                <span>有用</span>
            </div>
            <div class="" :class="{ active: faq.suggestionType == 2}" @click="onSuggestionClick(2)">
                <img class="useInfo-icon" src="https://resource.rcclchina.com.cn/Faq/nouseIconN.png" alt="没用">
                <img class="useInfo-iconActive" src="https://resource.rcclchina.com.cn/Faq/nouseIconWN.png" alt="没用">
                <span>没用</span>
            </div>
        </div>
        <div class="useInfo-resons" :style="nagtivePopupStyle">
            <div class="useInfo-closedBtn js-closedBtn" @click="isShowNagtivePopup=false" v-show="isShowNagtivePopup">
                <img src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/closed.png">
            </div>
            <div class="userInfo-resons-wrapper">
                <div class="useInfo-resonsTitle">您认为没用的信息：</div>
                <ul class="useInfo-resonsCon">
                    <li v-for="(item, i) in nagtiveItems" :key="('nagtiveItem_'+i)" @click="selectedNagtiveItem=item">
                        <input type="radio" name="useInfo" class="js-radioBtn" :checked="item==selectedNagtiveItem">
                        <span class="js-radioBtn">{{item}}</span>
                    </li>
                </ul>
                <div class="useInfo-resonsSubmit">
                    <button class="js-reasonSubmit" @click="onNagtiveSubmit">提交</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api'
export default {
    name: "FaqFeedback",
    props: {
        faq: {
            type: Object
        },
        selectedShipCategory: {
            type: Object
        },
        onFaqFeedbackSuccess: {
            type: Function
        }
    },
    data () {
        return {
            isShowNagtivePopup: false,
            nagtiveItems: [
                "信息有误",
                "信息不全",
                "描述有歧义",
                "问题和答案不符",
                "不是我想要的信息"
            ],
            selectedNagtiveItem: "",
            isSubmitting: false
        }
    },
    methods: {
        async onSuggestionClick (type) {
            if (this.faq.suggestionType > 0) {
                if (this.faq.suggestionType == type && type == 1) {
                    // cancel
                    if (!this.isSubmitting) {
                        const rewardToken = this.$store.state.user.userReviewToken
                        const requestData = {
                            faqId: this.faq.id,
                            userName: rewardToken,
                            shipCategory: this.selectedShipCategory.title,
                            shipSubCategory: this.selectedShipCategory.subTitle
                        }
                        this.isSubmitting = true
                        const { success, data } = await api.page.cancelFaqFeedback(requestData)
                        this.isSubmitting = false
                        if (success) {
                            this.onFaqFeedbackSuccess(this.faq.id, 0)
                        }
                        if (data && data.token && data.token.length > 0 && data.token != rewardToken) {
                            this.$store.commit('SET_REWARD_TOKEN', data.token)
                        }
                    }
                }
            } else if (type == 2) {
                this.isShowNagtivePopup = true
            } else {
                // submit positive
                if (!this.isSubmitting) {
                    const rewardToken = this.$store.state.user.userReviewToken
                    const requestData = {
                        faqId: this.faq.id,
                        userName: rewardToken,
                        shipCategory: this.selectedShipCategory.title,
                        shipSubCategory: this.selectedShipCategory.subTitle,
                        isGood: true
                    }
                    this.isSubmitting = true
                    const { success, data } = await api.page.submitFaqFeedback(requestData)
                    this.isSubmitting = false
                    if (success) {
                        this.onFaqFeedbackSuccess(this.faq.id, 1)
                    }
                    if (data && data.token && data.token.length > 0 && data.token != rewardToken) {
                        this.$store.commit('SET_REWARD_TOKEN', data.token)
                    }
                }
            }
        },
        async onNagtiveSubmit () {
            if (!this.selectedNagtiveItem && this.selectedNagtiveItem.length == 0) {
                this.$alert.show("请选择您认为没用的信息")
                return
            }
            if (!this.isSubmitting) {
                const rewardToken = this.$store.state.user.userReviewToken
                const requestData = {
                    faqId: this.faq.id,
                    userName: rewardToken,
                    shipCategory: this.selectedShipCategory.title,
                    shipSubCategory: this.selectedShipCategory.subTitle,
                    isGood: false,
                    suggestion: this.selectedNagtiveItem
                }
                this.isSubmitting = true
                const { success, data } = await api.page.submitFaqFeedback(requestData)
                this.isSubmitting = false
                if (success) {
                    this.onFaqFeedbackSuccess(this.faq.id, 2)
                    this.isShowNagtivePopup = false
                }
                if (data && data.token && data.token.length > 0 && data.token != rewardToken) {
                    this.$store.commit('SET_REWARD_TOKEN', data.token)
                }
            }
        }
    },
    computed: {
        nagtivePopupStyle () {
            if (this.isShowNagtivePopup) {
                return { 'height': '330px'}
            } else {
                return { 'height': 0}
            }
        }
    }
}
</script>

<style lang="less" scoped>

/**** 有用没用 ****/
.faDetail-useInfo {
    margin-top: 20px;
}
.faDetail-useInfo .useInfo-choice{
    overflow:hidden;
}
.faDetail-useInfo .useInfo-choice>div{
    margin-right:6px;
    /*background-color:#ececec;*/
    width:90px;
    height:30px;
    line-height:30px;
    text-align:center;
    float:left;
    cursor:pointer;
    border-radius:4px;
    font-size:0;
}
.faDetail-useInfo .useInfo-choice>div>img{
    vertical-align:middle;
    margin-right:4px;
}
.faDetail-useInfo .useInfo-choice>div>span{
    vertical-align:middle;
    font-size:13px;
    color:#888;
    margin-left:3px;
}
.faDetail-useInfo .useInfo-choice>div>img.useInfo-icon{
    display:inline-block;
}
.faDetail-useInfo .useInfo-choice>div>img.useInfo-iconActive{
    display:none;
}
.faDetail-useInfo .useInfo-choice > div.active{
    background-color:#1174b8;
}
.faDetail-useInfo .useInfo-choice > div.active>span {
    color:#fff;
}
.faDetail-useInfo .useInfo-choice>div.active>img.useInfo-icon{
    display:none;
}
.faDetail-useInfo .useInfo-choice>div.active>img.useInfo-iconActive{
    display:inline-block;
}
.faDetail-useInfo .useInfo-resons {
    position:absolute;
    display:block;
    z-index:1111;
    width:32%;
    transition: 0.3s all;
    min-width:250px;
    margin-top: 4px;
    background-color: #ececec;
    border-radius:4px;
    // display:none;
    box-shadow:0px 2px 8px rgba(0, 0, 0, 0.7);
    -webkit-box-shadow:0px 2px 8px rgba(0, 0, 0, 0.7);
    -moz-box-shadow:0px 2px 8px rgba(0, 0, 0, 0.7);

    .userInfo-resons-wrapper {
        position: relative;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        overflow: hidden;
    }
}
.faDetail-useInfo .useInfo-resons .useInfo-resonsTitle {
    font-size:13px;
    font-weight:bold;
    padding:14px;
    border-bottom:1px dashed #dadada;
}
.faDetail-useInfo .useInfo-resons .useInfo-resonsCon {
}
.faDetail-useInfo .useInfo-resons ul{
    margin:0;
    padding:14px;
}
.faDetail-useInfo .useInfo-resons ul li{
    margin-bottom:20px;
    cursor:pointer;
}
.faDetail-useInfo .useInfo-resons ul li input{
    width:16px;
    height:16px;
    vertical-align:middle;
    margin:0;
}
.faDetail-useInfo .useInfo-resons ul li span{
    color:#000;
    font-size:13px;
    margin-left:6px;
    display:inline-block;
    vertical-align:middle;
}
.faDetail-useInfo .useInfo-resonsSubmit{
    text-align:center;
}
.faDetail-useInfo .useInfo-resonsSubmit button{
    margin:0 auto;
    width:70px;
    height:30px;
    line-height:30px;
    color:#000;
    font-size:12px;
    background-color:#fcc300;
    border-radius:4px;
}

.faDetail-useInfo .useInfo-closedBtn {
    position:absolute;
    top: -20px;
    right: -20px;
    cursor:pointer;
    z-index: 1;
}
</style>